/**
 * Farbtöne für Projekt-Status (Pipeline-Phasen + Gewonnen/Verloren).
 *
 * Phasen-Labels sind pro Instanz frei konfigurierbar, deshalb wird über
 * Teilstrings gematcht statt über eine feste Werteliste.
 */

export type LeadStatusTone = {
  /** Hintergrund + Text + Ring für die Pille. */
  pill: string;
  /** Punkt links in der Pille. */
  dot: string;
};

const NEUTRAL_TONE: LeadStatusTone = {
  pill: 'bg-app-surface-muted text-app-text-muted ring-app-border',
  dot: 'bg-slate-400',
};

const TONE_BY_MATCH: Array<{ match: string; tone: LeadStatusTone }> = [
  { match: 'neu', tone: { pill: 'bg-blue-50 text-blue-700 ring-blue-200 dark:bg-blue-950/40 dark:text-blue-200 dark:ring-blue-800', dot: 'bg-blue-500' } },
  { match: 'kontakt', tone: { pill: 'bg-amber-50 text-amber-700 ring-amber-200 dark:bg-amber-950/40 dark:text-amber-200 dark:ring-amber-800', dot: 'bg-amber-500' } },
  { match: 'termin', tone: { pill: 'bg-purple-50 text-purple-700 ring-purple-200 dark:bg-purple-950/40 dark:text-purple-200 dark:ring-purple-800', dot: 'bg-purple-500' } },
  { match: 'angebot', tone: { pill: 'bg-indigo-50 text-indigo-700 ring-indigo-200 dark:bg-indigo-950/40 dark:text-indigo-200 dark:ring-indigo-800', dot: 'bg-indigo-500' } },
  { match: 'gewonnen', tone: { pill: 'bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-200 dark:ring-emerald-800', dot: 'bg-emerald-500' } },
  { match: 'abgeschlossen', tone: { pill: 'bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-200 dark:ring-emerald-800', dot: 'bg-emerald-500' } },
  { match: 'verloren', tone: { pill: 'bg-rose-50 text-rose-700 ring-rose-200 dark:bg-rose-950/40 dark:text-rose-200 dark:ring-rose-800', dot: 'bg-rose-500' } },
];

export function leadStatusTone(status: string | null | undefined): LeadStatusTone {
  const s = String(status ?? '').toLowerCase();
  if (!s) return NEUTRAL_TONE;
  return TONE_BY_MATCH.find((entry) => s.includes(entry.match))?.tone ?? NEUTRAL_TONE;
}
